<template>
  <div class="servicebox">
    <section id="banner">
      <div class="wrapper"></div>
    </section>
    <section id="breadcrumb">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <a >回首页</a>&nbsp;&gt;&nbsp;
        <a >关于我们</a>&nbsp;&gt;&nbsp;
        <a >公司簡介</a>
      </div>
    </section>
    <section id="content">
      <div class="wrapper">
        <h1 id="uiLbl_Title" class="title">公司簡介</h1>
        <div id="uiLbl_desc" class="des">
          <div
            class="subtitle"
          >汇迪森是一家以服务为导向的工业用储存装置供货商，专注于企业级、工业、航天与国防等应用市场，提供工业用嵌入式储存装置与工业用动态随机内存模块与相关技术服务。</div>
          <p>
            <br />在汇迪森，全部同仁都致力于服务我们的顾客与合作伙伴。「极致服务」是我们的企业文化，也是我们对顾客的承诺。透过「极致服务」的精神注入企业组织中的每一环，让顾客感受到我们友善且热情的服务。对我们来说，服务并不只是工作，而是汇迪森的本质，是同仁成就每一项任务的动力。
            <br />
            <br />对工业用储存装置产品来说，质量绝对是最基本也最重要的要求，因此，汇迪森坚持所有产品皆出自于我们通过认证的产线与厂房，全程控管生产流程，让产品在交到顾客手中前，都经过完整严格的测试，同时，自有产线与厂房也可弹性调配产线，提高生产效率，确保准确的交期。
            <br />
            <br />汇迪森在工业用嵌入式内存市场中，一向以专业负责的客制化服务傲视业界，我们的韧体研发团队全都是来自业界的专家，提供快速、弹性、符合特殊领域需求的技术支持，让我们的顾客得到满意地韧体客制化解决方案。
            <br />
            <br />我们也很自豪于总是保持对技术的创新。独特Pin7专利技术，让SATADOM系列产品可在没有外部电源线的情况下供电，这个突破性的设计已经得到Intel的认证，并且被广泛使用于工业用与嵌入式系统中，在全世界很多地方已可看到我们SATADOM产品的应用。
            <br />
            <br />秉持着「极致服务」的承诺、稳定质量的追求、客制化服务的专业和技术创新的热忱，汇迪森将持续在工控嵌入式储存装置领域，提供良好的产品与技术服务给我们的顾客与合作伙伴。
          </p>
          <div class="subtitle">
            2017年汇迪森企业影片
            <br />
            <br />
          </div>
          <center>
            <iframe
              src="https://www.youtube.com/embed/9mQHj5p1Nfg"
              width="560"
              height="315"
              frameborder="0"
              allowfullscreen="allowfullscreen"
            ></iframe>
            <br />
            <span
              style="color: #333333; font-size: 10pt;"
            >©2017 Hdstor Corporation. All Rights Reserved.</span>
          </center>
          <div style="text-align: center;">
            <span style="color: #808080; font-size: 10pt;">
              <a
                style="color: #808080; font-size: 10pt;"
                title="企业形象影片"
                
              >影片制作 By 见素影像</a>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "",
  data() {
    return {
      msg: "这是我的",
    };
  },
  components: {},
};
</script>

<style scoped >
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  background: url(../assets/20170519-17072284.jpg) center top no-repeat;
  background-size: 100% auto;
}
#banner .wrapper {
  background-size: auto 100% !important;
}
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper {
    height: 140px;
  }
}
@media screen and (max-width: 1300px) {
  section .wrapper {
    width:100%;
  }
}
@media screen and (max-width: 1000px) {
  #banner .wrapper {
    background-size: auto 100%;
  }
}

section#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
@media screen and (max-width: 760px) {
  section#breadcrumb .wrapper {
    padding: 10px;
    font-size: 12px;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 1000px) {
  section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
  }
}
#content .wrapper {
  width: 960px;
  padding: 40px 0;
  text-align: left;
  box-sizing: border-box;
}
@media screen and (max-width: 1300px) {
  .servicebox section .wrapper {
    width: 100%;
  }
}

#content .wrapper .title {
  font-size: 24px;
  color: #146cbd;
  padding: 20px 0;
  border-bottom: 1px #ccc solid;
  margin-bottom: 40px;
  font-family: latoweb;
}
#content .wrapper .des {
  line-height: 32px;
  font-size: 18px;
  padding: 0 0 40px;
  font-family: latoweblight;
  color: #666;
}
#content .wrapper .des a {
  font-size: 18px;
  line-height: 26px;
  padding: 0;
  font-family: latowebbold;
  text-decoration: underline;
  color: #15262e;
}
#content .wrapper .des .subtitle {
  font-size: 20px;
  font-family: latoweb;
  margin-top: 40px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cintroduction.vue